export function RouteFallback() {
  return (
    <div
      aria-busy="true"
      role="status"
      className="flex min-h-screen items-center justify-center bg-bg"
    >
      <div className="flex items-center gap-3 text-text-mute">
        <span
          className="inline-block h-2 w-2 animate-pulse rounded-full"
          style={{ background: 'var(--color-accent)' }}
        />
        <span className="font-mono uppercase" style={{ fontSize: 10, letterSpacing: '0.18em' }}>
          Cargando…
        </span>
      </div>
    </div>
  );
}
